// components/ProtectedRoute/RoleProtectedRoute.jsx
import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { CurrentUserContext } from "../../contexts/CurrentUserContext";
import { hasSessionToken } from "../../utilit/authSession";

export default function RoleProtectedRoute({
  element,
  isLogin,
  isReadyApp,
  allowedRoles = []
}) {
  // из контекста достаём именно kullanıcı
  const { currentUser } = useContext(CurrentUserContext);

  // 1) пока App ещё не завершил initApp() — ничего не рендерим
  if (!isReadyApp) return null;

  // 2) если не залогинен — кидаем на страницу входа
  if (!isLogin && !hasSessionToken()) return <Navigate to="/sign-in" replace />;

  // 3) если почта не подтверждена — на confirmation
  if (!currentUser?.isActivated) {
    return <Navigate to="/confirmation" replace />;
  }

  // 4) проверяем роли
  const userRoles = currentUser.roles || [];
  const hasRole = allowedRoles.some(role => userRoles.includes(role));
  if (!hasRole) return <Navigate to="/" replace />;

  // 5) всё ок — рендерим переданный компонент
  return element;
}
